/**
 * Calculadora de BTU - Polo Sul Climatizacao
 * Estimativa comercial para orientar a escolha do ar-condicionado.
 */

document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('btu-form');
  const btnCalculate = document.getElementById('btu-calculate-btn');
  const btnReset = document.getElementById('btu-reset-btn');

  if (!form || !btnCalculate) return;

  const commercialSizes = [7000, 9000, 12000, 18000, 24000, 30000, 36000, 48000, 60000, 80000];

  const moneyFormat = new Intl.NumberFormat('pt-BR');

  function numberValue(id, fallback) {
    const el = document.getElementById(id);
    if (!el) return fallback;
    const normalized = String(el.value || '').replace(',', '.');
    const value = parseFloat(normalized);
    return Number.isFinite(value) ? value : fallback;
  }

  function selectedRoomType() {
    return form.querySelector('input[name="roomType"]:checked')?.value || 'bedroom';
  }

  function getArea() {
    const directArea = numberValue('btu-area', 0);
    const width = numberValue('btu-width', 0);
    const length = numberValue('btu-length', 0);

    if (directArea > 0) return directArea;
    if (width > 0 && length > 0) return width * length;
    return 0;
  }

  function roundCommercialSize(rawBtu) {
    const recommended = commercialSizes.find((size) => rawBtu <= size);
    if (recommended) return recommended;
    return Math.ceil(rawBtu / 1000) * 1000;
  }

  function catalogFilterValue(size) {
    if (size >= 30000) return '30000-plus';
    return String(size);
  }

  function catalogUrlForBtu(size) {
    // Aponta para as colecoes reais de BTU (paginacao server-side correta) em vez do filtro client-side ps_btu
    var handle;
    if (size <= 9000) handle = '9000-btus';
    else if (size <= 12000) handle = '12000-btus';
    else if (size <= 18000) handle = '18000-btus';
    else if (size <= 24000) handle = '24000-btus';
    else handle = '30000-btus';
    return `/collections/${handle}`;
  }

  function recommendationOptions(recommendedBtu) {
    const index = commercialSizes.indexOf(recommendedBtu);
    const previous = index > 0 ? commercialSizes[index - 1] : null;
    const next = index >= 0 && index < commercialSizes.length - 1 ? commercialSizes[index + 1] : null;
    const options = [];

    if (previous && recommendedBtu <= 24000) {
      options.push({
        label: 'Opção econômica',
        size: previous,
        description: 'Pode atender ambientes com menor sol, boa vedação e pouca carga térmica.',
        main: false
      });
    }

    options.push({
      label: 'Mais indicado',
      size: recommendedBtu,
      description: 'Melhor equilíbrio para a carga informada e uma folga operacional segura.',
      main: true
    });

    if (next) {
      options.push({
        label: 'Mais folga',
        size: next,
        description: 'Boa escolha se o ambiente pega muito sol, tem portas abrindo ou uso mais intenso.',
        main: false
      });
    }

    return options;
  }

  function roomTypeAdjustment(roomType) {
    const map = {
      bedroom: { multiplier: 1, extra: 0, label: 'Quarto' },
      living: { multiplier: 1.05, extra: 0, label: 'Sala' },
      office: { multiplier: 1.08, extra: 0, label: 'Escritório' },
      kitchen: { multiplier: 1.12, extra: 2000, label: 'Cozinha' },
      commercial: { multiplier: 1.18, extra: 0, label: 'Comercial' }
    };
    return map[roomType] || map.bedroom;
  }

  function factorFromSelect(id, values) {
    const value = document.getElementById(id)?.value;
    return values[value] ?? values.default ?? 1;
  }

  function calculateBtu() {
    const area = getArea();
    const people = Math.max(1, Math.round(numberValue('btu-people', 1)));
    const equipment = Math.max(0, Math.round(numberValue('btu-equipment', 0)));
    const windows = Math.max(0, Math.round(numberValue('btu-windows', 0)));
    const roomType = selectedRoomType();
    const room = roomTypeAdjustment(roomType);

    if (area <= 0) {
      alert('Informe a área do ambiente ou preencha largura e comprimento.');
      return null;
    }

    if (area > 500) {
      alert('Para ambientes acima de 500 m2, recomendamos avaliação técnica personalizada.');
      return null;
    }

    const sunFactor = factorFromSelect('btu-sun', {
      shade: 0.95,
      morning: 1,
      afternoon: 1.12,
      all_day: 1.2,
      default: 1
    });

    const ceilingFactor = factorFromSelect('btu-ceiling', {
      standard: 1,
      high: 1.1,
      very_high: 1.22,
      default: 1
    });

    const insulationFactor = factorFromSelect('btu-insulation', {
      good: 0.95,
      average: 1,
      poor: 1.12,
      default: 1
    });

    const baseBtu = area * 600;
    const peopleBtu = Math.max(0, people - 2) * 600;
    const equipmentBtu = equipment * 600;
    const windowsBtu = windows * 250;
    const adjustedSubtotal = (baseBtu + peopleBtu + equipmentBtu + windowsBtu + room.extra) *
      sunFactor *
      ceilingFactor *
      insulationFactor *
      room.multiplier;

    const exactBtu = Math.round(adjustedSubtotal);
    const recommendedBtu = roundCommercialSize(exactBtu);

    return {
      area,
      people,
      equipment,
      windows,
      room,
      exactBtu,
      recommendedBtu,
      breakdown: [
        ['Área', `${area.toLocaleString('pt-BR', { maximumFractionDigits: 1 })} m2`],
        ['Pessoas', `${people}`],
        ['Eletrônicos', `${equipment}`],
        ['Janelas', `${windows}`],
        ['Ambiente', room.label],
        ['Carga estimada', `${moneyFormat.format(exactBtu)} BTU/h`]
      ]
    };
  }

  function recommendationNote(result) {
    if (result.exactBtu > 60000) {
      return 'Ambiente de alta carga térmica. Para este caso, vale falar com um especialista para avaliar instalação, quantidade de evaporadoras e carga elétrica.';
    }

    if (result.recommendedBtu - result.exactBtu > 3500) {
      return 'A capacidade comercial acima foi escolhida para evitar subdimensionamento e manter folga operacional.';
    }

    return 'Resultado estimado. Cortinas, incidência solar real, isolamento e quantidade de equipamentos podem alterar a capacidade ideal.';
  }

  function renderResult(result) {
    const resultDiv = document.getElementById('btu-result');
    const valueSpan = document.getElementById('btu-value');
    const exactText = document.getElementById('btu-exact');
    const breakdown = document.getElementById('btu-breakdown');
    const note = document.getElementById('btu-note');
    const shopLink = document.getElementById('btu-shop-link');
    const recommendations = document.getElementById('btu-recommendations');

    valueSpan.textContent = moneyFormat.format(result.recommendedBtu);
    exactText.textContent = `Cálculo aproximado: ${moneyFormat.format(result.exactBtu)} BTU/h.`;
    note.textContent = recommendationNote(result);

    breakdown.innerHTML = result.breakdown.map(([label, value]) => `
      <div class="btu-breakdown__item">
        <strong>${label}</strong>
        <span>${value}</span>
      </div>
    `).join('');

    const options = recommendationOptions(result.recommendedBtu);
    recommendations.innerHTML = options.map((option) => `
      <div class="btu-recommendation-card${option.main ? ' is-main' : ''}">
        <strong>${option.label}: ${moneyFormat.format(option.size)} BTUs</strong>
        <span>${option.description}</span>
        <a href="${catalogUrlForBtu(option.size)}">Ver modelos de ${moneyFormat.format(option.size)} BTUs</a>
      </div>
    `).join('');

    shopLink.href = catalogUrlForBtu(result.recommendedBtu);
    shopLink.textContent = `Ver modelos de ${moneyFormat.format(result.recommendedBtu)} BTUs`;

    resultDiv.style.display = 'block';
    resultDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  btnCalculate.addEventListener('click', function() {
    const result = calculateBtu();
    if (result) renderResult(result);
  });

  form.addEventListener('submit', function(event) {
    event.preventDefault();
    const result = calculateBtu();
    if (result) renderResult(result);
  });

  if (btnReset) {
    btnReset.addEventListener('click', function() {
      form.reset();
      document.getElementById('btu-result').style.display = 'none';
      document.getElementById('btu-area').focus();
    });
  }
});
